"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _flattenAndConcatenateKeysWithNamespace = require("./flattenAndConcatenateKeysWithNamespace");
Object.keys(_flattenAndConcatenateKeysWithNamespace).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _flattenAndConcatenateKeysWithNamespace[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _flattenAndConcatenateKeysWithNamespace[key];
    }
  });
});
var _mapTranslationsToKeys = require("./mapTranslationsToKeys");
Object.keys(_mapTranslationsToKeys).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapTranslationsToKeys[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapTranslationsToKeys[key];
    }
  });
});
var _mapNamespacedTranslations = require("./mapNamespacedTranslations");
Object.keys(_mapNamespacedTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapNamespacedTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapNamespacedTranslations[key];
    }
  });
});
//# sourceMappingURL=index.js.map